import { create } from 'zustand';
import type { BreathworkWorkout } from '@breath-lab/types';
import { getServices } from '@breath-lab/services';

interface WorkoutsState {
  workouts: BreathworkWorkout[];
  isLoaded: boolean;
  isLoading: boolean;
  error: boolean;

  // selectors
  getWorkoutById: (id: string) => BreathworkWorkout | undefined;

  // actions
  load: (userId: string) => Promise<void>;
  addWorkout: (workout: BreathworkWorkout) => void;
  updateWorkout: (workoutId: string, fields: Partial<BreathworkWorkout>) => void;
  reset: () => void;
}

export const useWorkouts = create<WorkoutsState>((set, get) => ({
  workouts: [],
  isLoaded: false,
  isLoading: false,
  error: false,

  getWorkoutById: (id) => get().workouts.find((w) => w.id === id),

  load: async (userId) => {
    if (get().isLoaded || get().isLoading) return;
    set({ isLoading: true, error: false });
    try {
      const workouts = await getServices().userData.fetchWorkouts(userId);
      set({ workouts, isLoading: false, isLoaded: true });
    } catch {
      set({ isLoading: false, error: true });
    }
  },

  addWorkout: (workout) => {
    set((state) => ({ workouts: [workout, ...state.workouts] }));
  },

  updateWorkout: (workoutId, fields) => {
    set((state) => ({
      workouts: state.workouts.map((w) =>
        w.id === workoutId ? { ...w, ...fields } : w
      ),
    }));
  },

  reset: () => set({ workouts: [], isLoaded: false, isLoading: false, error: false }),
}));
